<template>
  <div
    :class="{
      'menu-background': !isSidebarCollapsed,
      'menu-bg-short': isSidebarCollapsed,
      animated,
      slideIn
    }"
    :collapse="isSidebarCollapsed"
    :background-color="getTheme['$background-color']"
    :text-color="getTheme['$text-color']"
    :active-text-color="getTheme['$active-text-color']"
  >
    <!-- <div
      style="margin: 9px 0px; padding-left: 17px; width: 100%; overflow: hidden"
    > -->
    <div :class="{ 'center-align': isSidebarCollapsed }">
      <img
        v-show="!isSidebarCollapsed"
        :src="require('../assets/img/white-logo.svg')"
        alt
        style="max-width: 160px"
      />
      <img
        v-show="isSidebarCollapsed"
        :src="require('../assets/img/white-logo-strip.svg')"
        style="margin: 0 auto;"
        alt
      />
      <!-- <p v-show="isSidebarCollapsed" style="width: 130px; height: 74px"></p> -->
    </div>
    <!-- <div class="sidebar-user-top">
        <img src="https://source.unsplash.com/100x100/weekly?profile,picture" alt="" class="user-avatar">
        <div class="user-details">
            <div class="user-name"> {{ (this.getUserSession !== null) ? this.getUserSession.firstName + ' ' + this.getUserSession.lastName : '' }}</div>
            <div class="user-email">{{ (this.getUserSession !== null) ? this.getUserSession.email : '' }}</div>
        </div>
    </div>-->
    <!-- <router-link :to="`/users/edit/${props.row.id}`"> -->

    <div index="0" class="profile-box">
      <router-link
        :to="
          `/profile/edit/${
            this.getUserSession !== null ? this.getUserSession.id : ''
          }`
        "
      >
        <div class="profile-content">
          <div class="profile-picture">
            <img src="@/assets/img/avatar.png" alt class="user-avatar" />
          </div>
          <div slot="title" v-show="!isSidebarCollapsed" class="user-details">
            {{
              this.getUserSession !== null
                ? this.getUserSession.firstName +
                  " " +
                  this.getUserSession.lastName
                : ""
            }}
            <div class="user-email">
              {{
                this.getUserSession !== null ? this.getUserSession.email : ""
              }}
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <p class="menu-title">Menu</p>
    <!-- <router-link :to="`/profile/edit/${this.getUserSession.id}`">
      <div index="0" class="sidebar-user-top" >
        <img src="@/assets/img/avatar.png" alt class="user-avatar" />
        <div  slot="title" v-show="!isSidebarCollapsed" class="user-details">
          {{
            this.getUserSession !== null
              ? this.getUserSession.firstName + " " + this.getUserSession.lastName
              : ""
          }}
          <div class="user-email">
            {{ this.getUserSession !== null ? this.getUserSession.email : "" }}
          </div>
        </div>
      </div>
    </router-link> -->
    <can I="manage" a="demo">
      <el-tooltip
        class
        effect="customized"
        :content="'Dashboard Summary (Demo)'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="20"
          @click="navTo('dashboardSummary')"
          class="menu-collapse"
        >
          <i class="fa fa-home icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="20"
        @click="navTo('dashboardSummary')"
        class="menu-item"
      >
        <i class="fa fa-home icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">
          Dashboard Summary (Demo)
        </p>
      </div>
    </can>

    <can I="manage" a="mine">
      <!--  index="20" -->
      <el-tooltip
        class
        effect="customized"
        :content="'Dashboard'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div @click="navTo('customerDashboard')" class="menu-collapse">
          <img
            :class="{ 'smaller-img': isSidebarCollapsed }"
            :src="require('../assets/img/dashboard-icon.png')"
          />
          <!-- <i class="fa fa-home icon-side"></i> -->
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        @click="navTo('customerDashboard')"
        class="menu-item"
      >
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/dashboard-icon.png')"
        />
        <!-- <i class="fa fa-home icon-side"></i> -->
        <p slot="title" v-show="!isSidebarCollapsed">Dashboard</p>
      </div>
    </can>

    <can I="manage" a="mine">
      <el-tooltip
        class
        effect="customized"
        :content="'Performance'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="1"
          class="menu-collapse"
          @click="isOnboardingLoacation ? null : navTo('Home')"
        >
          <img
            :class="{ 'smaller-img': isSidebarCollapsed }"
            :src="require('../assets/img/performance-icon.png')"
          />
          <!-- <i class="fa fa-plug icon-side"></i> -->
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="1"
        class="menu-item"
        @click="isOnboardingLoacation ? null : navTo('Home')"
      >
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/performance-icon.png')"
        />
        <!-- <i class="fa fa-plug icon-side"></i> -->
        <p slot="title" v-show="!isSidebarCollapsed">Performance</p>
      </div>
    </can>

    <can I="manage" a="installation">
      <el-tooltip
        class
        effect="customized"
        :content="'Dashboard'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="1"
          class="menu-collapse"
          @click="isOnboardingLoacation ? null : navTo('Home')"
        >
          <i class="fa fa-home icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="1"
        class="menu-item"
        @click="isOnboardingLoacation ? null : navTo('Home')"
      >
        <i class="fa fa-home icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Dashboard</p>
      </div>
    </can>

    <can I="create" a="packages">
      <el-tooltip
        class
        effect="customized"
        :content="'Product Packages'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="2" @click="navTo('packages')" class="menu-collapse">
          <i class="fa fa-list icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="2"
        @click="navTo('packages')"
        class="menu-item"
      >
        <i class="fa fa-list icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Product Packages</p>
      </div>
    </can>

    <!-- @todo: reafactor this for customers and stop fetching all customers data -->
    <can I="manage" a="allDevices">
      <el-tooltip
        class
        effect="customized"
        :content="'Installation Management'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="4" @click="navTo('devices')" class="menu-collapse">
          <i class="fa fa-desktop icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="4"
        @click="navTo('devices')"
        class="menu-item"
      >
        <i class="fa fa-desktop icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Installation Management</p>
      </div>
    </can>

    <can I="manage" a="allDevices">
      <el-tooltip
        class
        effect="customized"
        :content="'Exclusions'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="4" @click="navTo('exclusionList')" class="menu-collapse">
          <i class="fa fa-desktop icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="4"
        @click="navTo('exclusionList')"
        class="menu-item"
      >
        <i class="fa fa-desktop icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Exclusions</p>
      </div>
    </can>
    <!-- <can I="manage" a="installation">
      <div index="4" @click="navTo('devices')">
        <i class="fa fa-desktop icon-side"></i>
        <p  slot="title" v-show="!isSidebarCollapsed">Installation Management df</p>
      </div>
    </can> -->
    <!-- <can I="read" a="payments">
      <div index="12" @click="navTo('payments')">
        <i class="fa fa-credit-card icon-side"></i>
        <p  slot="title" v-show="!isSidebarCollapsed">Payments</p>
      </div>
    </can>-->
    <can I="read" a="performance">
      <el-tooltip
        class
        effect="customized"
        :content="'Performance'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="3"
          @click="navToPath('/performance/live')"
          class="menu-collapse"
        >
          <!-- <i class="fa fa-chart-bar icon-side"></i> -->
          <img
            :class="{ 'smaller-img': isSidebarCollapsed }"
            :src="require('../assets/img/performance-icon.png')"
          />
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="3"
        @click="navToPath('/performance/live')"
        class="menu-item"
      >
        <!-- <i class="fa fa-chart-bar icon-side"></i> -->
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/performance-icon.png')"
        />
        <p slot="title" v-show="!isSidebarCollapsed">Performance</p>
      </div>
    </can>

    <can I="see" a="warnings">
      <el-tooltip
        class
        effect="customized"
        :content="'Alarm'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="16" @click="navTo('warnings')" class="menu-collapse">
          <!-- <i class="fa fa-bell icon-side"></i> -->
          <img
            :class="{ 'smaller-img': isSidebarCollapsed }"
            :src="require('../assets/img/alarm-icon.png')"
          />
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="16"
        @click="navTo('warnings')"
        class="menu-item"
      >
        <!-- <i class="fa fa-bell icon-side"></i> -->
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/alarm-icon.png')"
        />
        <p slot="title" v-show="!isSidebarCollapsed">Alarm</p>
      </div>
    </can>

    <can I="see" a="customerWarning">
      <el-tooltip
        class
        effect="customized"
        :content="'Alarm'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="18"
          @click="navTo('customerWarnings')"
          class="menu-collapse"
        >
          <img
            :class="{ 'smaller-img': isSidebarCollapsed }"
            :src="require('../assets/img/alarm-icon.png')"
          />
          <!-- <i class="fa fa-bell icon-side"></i> -->
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="18"
        @click="navTo('customerWarnings')"
        class="menu-item"
      >
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/alarm-icon.png')"
        />
        <!-- <i class="fa fa-bell icon-side"></i> -->
        <p slot="title" v-show="!isSidebarCollapsed">Alarm</p>
      </div>
    </can>
    <!-- <can I="manage" a="installation">
      <div index="11" @click="navTo('geoDistribution')">
        <i class="fa fa-map icon-side"></i>
        <p  slot="title" v-show="!isSidebarCollapsed">Geo Distribution</p>
      </div>
    </can> -->

    <can I="manage" a="user">
      <el-tooltip
        class
        effect="customized"
        :content="'Users Management'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="5"
          @click="navToPath('/user_management/users')"
          class="menu-collapse"
        >
          <i class="fa fa-user-plus icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="5"
        @click="navToPath('/user_management/users')"
        class="menu-item"
      >
        <i class="fa fa-user-plus icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Users Management</p>
      </div>
    </can>

    <!-- Billing -->
    <can I="manage" a="bills">
      <el-tooltip
        class
        effect="customized"
        :content="'Billing'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="25"
          @click="navToPath('/admin-billing')"
          class="menu-collapse"
        >
          <img
            :class="{ 'smaller-img': isSidebarCollapsed }"
            :src="require('../assets/img/billing-icon.png')"
          />
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="25"
        @click="navToPath('/admin-billing')"
        class="menu-item"
      >
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/billing-icon.png')"
        />
        <!-- <i class="fa fa-credit-card icon-side"></i> -->
        <p slot="title" v-show="!isSidebarCollapsed">Billing</p>
      </div>
    </can>

    <can I="manage" a="bills">
      <el-tooltip
        class
        effect="customized"
        :content="'Transaction History'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="26"
          @click="navToPath('/admin-transaction-history')"
          class="menu-collapse"
        >
          <i class="fa fa-history icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="26"
        @click="navToPath('/admin-transaction-history')"
        class="menu-item"
      >
        <i class="fa fa-history icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Transaction History</p>
      </div>
    </can>

    <can I="manage" a="onbbb" class="">
      <el-tooltip
        class
        effect="customized"
        :content="'Customer Admin Onboarding'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="16"
          @click="navToPath('/customer_admin/customers')"
          class="menu-collapse"
        >
          <i class="fa fa-list-alt icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="16"
        @click="navToPath('/customer_admin/customers')"
        class="menu-item"
      >
        <i class="fa fa-list-alt icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">
          Customer Admin Onboarding
        </p>
      </div>
    </can>

    <can I="manage" a="payment">
      <el-tooltip
        class
        effect="customized"
        :content="'Payment'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="16"
          class="menu-collapse"
          @click="navToPath('/customer_payment/payment_schedule')"
        >
          <i class="fa fa-list-alt icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="16"
        class="menu-item"
        @click="navToPath('/customer_payment/payment_schedule')"
      >
        <i class="fa fa-list-alt icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Payment</p>
      </div>
    </can>

    <can I="create" a="inventorygg">
      <el-tooltip
        class
        effect="customized"
        :content="'Inventory'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="6" @click="navTo('inventory')" class="menu-collapse">
          <i class="fa fa-list-alt icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="6"
        @click="navTo('inventory')"
        class="menu-item"
      >
        <i class="fa fa-list-alt icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Inventory</p>
      </div>
    </can>

    <can I="manage" a="customer">
      <el-tooltip
        class
        effect="customized"
        :content="'Customers'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="7" @click="navTo('customers')" class="menu-collapse">
          <i class="fa fa-users icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="7"
        @click="navTo('customers')"
        class="menu-item"
      >
        <i class="fa fa-users icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Customers</p>
      </div>
    </can>

    <can I="see" a="maintenance">
      <el-tooltip
        class
        effect="customized"
        :content="'Maintenance'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="8" @click="navTo('support')" class="menu-collapse">
          <i class="fa fa-wrench icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="8"
        @click="navTo('support')"
        class="menu-item"
      >
        <i class="fa fa-wrench icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Maintenance</p>
      </div>
    </can>

    <can I="manage" a="report">
      <el-tooltip
        class
        effect="customized"
        :content="'Reports'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="9" @click="navTo('reports')" class="menu-collapse">
          <i class="fa fa-file icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="9"
        @click="navTo('reports')"
        class="menu-item"
      >
        <i class="fa fa-file icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Reports</p>
      </div>
    </can>

    <!-- admin can only manage invoices or refactor the way invoices are managed -->
    <can I="manage" a="allDevices">
      <el-tooltip
        class
        effect="customized"
        :content="'Invoices'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="10" @click="navTo('invoices')" class="menu-collapse">
          <i class="fa fa-receipt icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="10"
        @click="navTo('invoices')"
        class="menu-item"
      >
        <i class="fa fa-receipt icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Invoices</p>
      </div>
    </can>

    <can I="see" a="proforma">
      <el-tooltip
        class
        effect="customized"
        :content="'Proforma'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="15" @click="navTo('proforma')" class="menu-collapse">
          <i class="fa fa-desktop icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="15"
        @click="navTo('proforma')"
        class="menu-item"
      >
        <i class="fa fa-desktop icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Proforma</p>
      </div>
    </can>

    <can I="manage" a="allDevices">
      <el-tooltip
        class
        effect="customized"
        :content="'Device Expiry Report'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="19" @click="navTo('devices-status')" class="menu-collapse">
          <i class="fa fa-exclamation-triangle icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="19"
        @click="navTo('devices-status')"
        class="menu-item"
      >
        <i class="fa fa-exclamation-triangle icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Device Expiry Report</p>
      </div>
    </can>

    <can I="see" a="billing">
      <el-tooltip
        class
        effect="customized"
        :content="'Billing'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="23" @click="navTo('billing')" class="menu-collapse">
          <img
            :class="{ 'smaller-img': isSidebarCollapsed }"
            :src="require('../assets/img/billing-icon.png')"
          />
          <!-- <i class="fa fa-credit-card icon-side"></i> -->
          <!-- <p slot="title" v-show="!isSidebarCollapsed">Billing</p> -->
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="23"
        @click="navTo('billing')"
        class="menu-item"
      >
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/billing-icon.png')"
        />
        <!-- <i class="fa fa-credit-card icon-side"></i> -->
        <p slot="title" v-show="!isSidebarCollapsed">Billing</p>
      </div>
    </can>

    <!-- Section manager Priviledge -->
    <can I="am" a="sm">
      <el-tooltip
        class
        effect="customized"
        :content="'API Keys'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="23" @click="navTo('access-key')" class="menu-collapse">
          <i class="fa fa-key" aria-hidden="true"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="23"
        @click="navTo('access-key')"
        class="menu-item"
      >
        <i class="fa fa-key" aria-hidden="true"></i>
        <p slot="title" v-show="!isSidebarCollapsed">API Keys</p>
      </div>
    </can>

    <!-- Admin Accesses Partner Request -->
    <can I="manage" a="allDevices">
      <el-tooltip
        class
        effect="customized"
        :content="'Request Access'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="31" @click="navTo('request-access')" class="menu-collapse">
          <i class="fa fa-address-book" aria-hidden="true"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="31"
        @click="navTo('request-access')"
        class="menu-item"
      >
        <i class="fa fa-address-book" aria-hidden="true"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Request Access</p>
      </div>
    </can>

    <!-- Admin Access Partner Metrics -->
    <can I="manage" a="allDevices">
      <el-tooltip
        class
        effect="customized"
        :content="'Partner Metrics'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="33" @click="navTo('partner-metrics')" class="menu-collapse">
          <i class="fa fa-address-book" aria-hidden="true"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="33"
        @click="navTo('partner-metrics')"
        class="menu-item"
      >
        <i class="fa fa-address-book" aria-hidden="true"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Partner Metrics</p>
      </div>
    </can>

    <can I="manage" a="onboardingTracker">
      <el-tooltip
        class
        effect="customized"
        :content="'Onboarding Tracker'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div
          index="21"
          @click="navTo('onboarding-tracker')"
          class="menu-collapse"
        >
          <i class="fa fa-desktop icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="21"
        @click="navTo('onboarding-tracker')"
        class="menu-item"
      >
        <i class="fa fa-desktop icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Onboarding Tracker</p>
      </div>
    </can>

    <!-- Lux-Solarbase integration -->
    <can I="manage" a="onboardingTracker">
      <el-tooltip
        class
        effect="customized"
        :content="'Lux Onboarding'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="7" @click="navTo('lux-onboarding')" class="menu-collapse">
          <i class="fa fa-desktop icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="7"
        @click="navTo('lux-onboarding')"
        class="menu-item"
      >
        <i class="fa fa-desktop icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Lux Onboarding</p>
      </div>
    </can>

    <!-- Opulence Admin Integration -->
    <can I="manage" a="onboardingTracker">
      <el-tooltip
        class
        effect="customized"
        :content="'Arnergy Products'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="7" @click="navTo('arnergy-products')" class="menu-collapse">
          <i class="fa fa-archive"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="7"
        @click="navTo('arnergy-products')"
        class="menu-item"
      >
        <i class="fa fa-archive"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Arnergy Products</p>
      </div>
    </can>

    <can I="manage" a="subsmanager">
      <el-tooltip
        class
        effect="customized"
        :content="'Recurring Invoice Mgmt.'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="11" @click="navTo('subsmanager')" class="menu-collapse">
          <i class="fa fa-exclamation-circle icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="11"
        @click="navTo('subsmanager')"
        class="menu-item"
      >
        <i class="fa fa-exclamation-circle icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Recurring Invoice Mgmt.</p>
      </div>
    </can>

    <can I="am" a="sudo">
      <el-tooltip
        class
        effect="customized"
        :content="'Report Config'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="17" @click="navTo('reportConfig')" class="menu-collapse">
          <i class="fa fa-cog icon-side"></i>
          <p slot="title" v-show="!isSidebarCollapsed">Report Config</p>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="17"
        @click="navTo('reportConfig')"
        class="menu-item"
      >
        <i class="fa fa-cog icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Report Config</p>
      </div>
    </can>

    <can I="manage" a="alarmConfig">
      <el-tooltip
        class
        effect="customized"
        :content="'Alarm Config'"
        placement="right"
        v-if="isSidebarCollapsed"
      >
        <div index="13" @click="navTo('alarmConfig')" class="menu-collapse">
          <i class="fa fa-bell-o icon-side"></i>
        </div>
      </el-tooltip>

      <div
        v-if="!isSidebarCollapsed"
        index="13"
        @click="navTo('alarmConfig')"
        class="menu-item"
      >
        <i class="fa fa-bell-o icon-side"></i>
        <p slot="title" v-show="!isSidebarCollapsed">Alarm Config</p>
      </div>
    </can>

    <div class="divider"></div>

    <el-tooltip
      class
      effect="customized"
      :content="'Logout'"
      placement="right"
      v-if="isSidebarCollapsed"
    >
      <div index="14" @click="logout" class="menu-collapse">
        <img
          :class="{ 'smaller-img': isSidebarCollapsed }"
          :src="require('../assets/img/logout-icon.png')"
        />
      </div>
    </el-tooltip>

    <div
      v-if="!isSidebarCollapsed"
      index="14"
      @click="logout"
      class="menu-item"
    >
      <img
        :class="{ 'smaller-img': isSidebarCollapsed }"
        :src="require('../assets/img/logout-icon.png')"
      />
      <!-- <i class="fa fa-power-off icon-side"></i> -->
      <p slot="title" v-show="!isSidebarCollapsed">Logout</p>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import { Menu, Submenu, MenuItem, MenuItemGroup, Tooltip } from "element-ui";
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
export default {
  name: "sidebar",
  props: ["collapse"],
  components: {
    "el-tooltip": Tooltip
  },
  data() {
    return {
      logoWhite: "",
      isCollapse: false,
      onboardingState: false
    };
  },
  methods: {
    ...mapActions(["setUserSession"]),
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    navToPath(page) {
      this.$router.replace({
        path: page,
        params: {}
      });
      // document.getElementById("menu_pin").click();
      // console.log(user);
    },
    navTo(page) {
      if (page == "devices") {
        this.$router.push({
          name: page,
          params: {
            activetab: this.$can("manage", "mine")
              ? "device_request"
              : this.$can("am", "manager") || this.$can("am", "engineer")
              ? "all_devices"
              : "manage_requests"
          }
        });
      } else if (page == "user_management") {
        this.$router.push({
          name: page,
          params: {
            activetab: this.$can("manage", "mine")
              ? "device_request"
              : this.$can("am", "manager") || this.$can("am", "engineer")
              ? "users"
              : "customer_group"
          }
        });
      } else {
        this.$router.push({
          name: page,
          params: {}
        });
        // document.getElementById("menu_pin").click();
        // console.log(user);
      }
    },
    shutDoor() {
      // console.log(this.slideout);
    },
    logout() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.post("/users/logout", {})
        .then(response => {
          container.setUserSession(null);
          localStorage.userToken = null;
          setTimeout(() => {
            // container.$router.push({ path: "/auth/login" });
            window.location.reload();
          }, 300);
        })
        .catch(e => {
          container.setUserSession(null);
          setTimeout(() => {
            window.location.reload();
          }, 300);
        });
    }
  },
  computed: {
    ...mapGetters(["getUserSession", "getTheme", "isSidebarCollapsed"]),
    isOnboardingLoacation: {
      get() {
        return window.location.pathname == `/onboarding`;
      }
    }
  },
  mounted() {
    if (!this.$can("all", "anon")) {
      // this.$router.push({ path: "/" });
      // return
    }
    if (localStorage.customerId) this.onboardingState = true;
    else this.onboardingState = false;
  },
  directives: {
    ClickOutside
  }
};
</script>

<style scoped>
.menu-background {
  background-color: #3b83b3;
  width: 256px;
  height: 100%;
  padding: 24px 16px;
  overflow-y: scroll;
  position: relative;
}
.menu-bg-short {
  background-color: #3b83b3;
  width: fit-content;
  height: 100%;
  padding: 24px 16px;
  overflow-y: scroll;
  position: relative;
}
.menu-title {
  font-size: 12;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 48px;
  margin-bottom: 16px;
}
.icon-side {
  margin-right: 12px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 16px 12px;
  cursor: pointer;
}

.menu-collapse {
  display: flex;
  align-items: center;
  padding: 16px 12px;
  cursor: pointer;
}

.menu-collapse:hover {
  background-color: #0c619b;
  border-radius: 10px;
}

.menu-item:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
}
.active-menu {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
}

.menu-item img {
  max-width: 16px;
}

.menu-collapse img {
  max-width: 16px;
}

.menu-item i {
  max-width: 16px;
  color: #fff;
  margin-right: 0;
}

.menu-collapse i {
  max-width: 16px;
  color: #fff;
  margin-right: 0;
}

.menu-item img.smaller-img {
  max-width: 14px;
}

.menu-collapse img.smaller-img {
  max-width: 14px;
}

.menu-item p {
  color: #fff;
  font-size: 13px;
  font-weight: 100;
  margin-left: 12px;
  margin-bottom: 0px;
}

.menu-collapse p {
  color: #fff;
  font-size: 13px;
  font-weight: 100;
  margin-left: 12px;
  margin-bottom: 0px;
}
.divider {
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.25);
  margin: 50px 0px;
}
.center-align {
  display: flex;
  justify-content: center;
}
.profile-box {
  margin-top: 24px;
}
.profile-content {
  display: flex;
  align-items: center;
}
.profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.user-details {
  margin-left: 12px;
  font-size: 13px;
  color: #fff;
}
.user-email {
  font-size: 9.5px;
  color: rgba(255, 255, 255, 0.75);
}
::-moz-scrollbar-button:decrement,
::-moz-scrollbar-button:increment,
::-webkit-scrollbar-button:decrement,
::-webkit-scrollbar-button:increment {
  width: 0px;
}

.sidebar {
  position: static;
  width: initial;
  height: inherit;
  margin-left: 0px;
}

.sidebar__user {
  padding: 40px 15px !important;
}

.sidebar-subnav {
  display: inherit;
}

ul.sidebar-subnav {
  margin: 0px !important;
}

.card-body {
  padding: 0px !important;
  margin: 0px !important;
}

.p-1 {
  padding: 0px !important;
  margin: -1px -2px !important;
}

a.btn-info {
  background-color: #2c3e50 !important;
  border-color: #2c3e50 !important;
  padding: 15px 22px;
}

.card-header {
  border-color: transparent;
  border: none;
}

.btn {
  justify-content: left !important;
}

p.sidebar-unique {
  margin-right: 11px !important;
  color: #939daa;
}

p.sidebar-collapse-text {
  font-size: 15px;
  color: #939daa;
}

a.btn-info:hover,
a.btn-info:focus {
  background-color: #253749 !important;
  color: #fff;
}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
  .el-menu-vertical-dash {
    transition: ease-in-out;
  }

  .el-menu-vertical-dash.el-menu--collapse {
    width: 0px;
    overflow: hidden;
    /* margin-left: -100%; */
  }
}

.el-menu--collapse {
  width: 64px;
}

.el-menu-vertical-dash {
  height: 100%;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue